import { Formik, Form, ErrorMessage, Field } from 'formik'
import React, { useEffect } from 'react'
import {
  GlobalSettingValidation,
} from '../../../../Utils/_helpers/ValidationSchema'
import { useDispatch, useSelector } from 'react-redux'
import {
  GetGlobalSetting,
  UpdateGlobalSetting,
  getGlobalSetting,
} from './GlobalSettingSlice/GlobalSettingSlice'

import { Form as BSForm } from 'react-bootstrap'

const GlobalSetting = () => {
  const dispatch = useDispatch()
  const GetGlobalSettingData: any = useSelector(getGlobalSetting)

  useEffect(() => {
    dispatch(GetGlobalSetting())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className='card'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-600-800'>Global setting</h3>
          </div>
        </div>
        {GetGlobalSettingData && (
          <div className='card-body pt-0'>
            <Formik
              initialValues={GetGlobalSettingData}
              validationSchema={GlobalSettingValidation}
              onSubmit={(values: any) => {
                dispatch(UpdateGlobalSetting({ name: 'GLOBAL_SETTING', value: values }))
              }}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <div className='row p-5'>
                    <h5 className='text-gray-600'>Minimum Purchase credit</h5>
                    <div className='row'>
                      <div className='col-6'>
                        <Field
                          placeholder={'MIN_PURCHASES_SMS_CERDIT'}
                          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                          name='MIN_PURCHASES_SMS_CERDIT'
                          type='text'
                        />
                        <ErrorMessage
                          className='text-danger'
                          name='MIN_PURCHASES_SMS_CERDIT'
                          component='div'
                        />
                      </div>
                      <div className='col-6'>
                        <Field
                          placeholder={'MIN_PURCHASES_MMS_CERDIT'}
                          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                          name='MIN_PURCHASES_MMS_CERDIT'
                          type='text'
                        />
                        <ErrorMessage
                          className='text-danger'
                          name='MIN_PURCHASES_MMS_CERDIT'
                          component='div'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='row p-5'>
                    <h5 className='text-gray-600'>User signup credit</h5>
                    <div className='row'>
                      <div className='col-6'>
                        <Field
                          placeholder={'USER_SIGNUP_SMS_CREDIT'}
                          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                          name='USER_SIGNUP_SMS_CREDIT'
                          type='text'
                        />
                        <ErrorMessage
                          className='text-danger'
                          name='USER_SIGNUP_SMS_CREDIT'
                          component='div'
                        />
                      </div>
                      <div className='col-6'>
                        <Field
                          placeholder={'USER_SIGNUP_MMS_CREDIT'}
                          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                          name='USER_SIGNUP_MMS_CREDIT'
                          type='text'
                        />
                        <ErrorMessage
                          className='text-danger'
                          name='USER_SIGNUP_MMS_CREDIT'
                          component='div'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='row p-5'>
                    <h5 className='text-gray-600'>user signup popup</h5>
                    <div className='row'>
                      <div className='col-6'>
                        <Field
                          placeholder={'USER_SIGNUP_POPUP_SMS_CREDIT'}
                          className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                          name='USER_SIGNUP_POPUP_SMS_CREDIT'
                          type='text'
                        />
                        <ErrorMessage
                          className='text-danger'
                          name='USER_SIGNUP_POPUP_SMS_CREDIT'
                          component='div'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='row p-5'>
                    <div className='d-flex align-items-center mb-4 gap-4'>
                      <h5 className='text-gray-600 mb-0'>Additional Fee</h5>
                      <div className='form-check form-switch'>
                        <Field
                          type='checkbox'
                          name='ENABLE_ADDITIONAL_FEE'
                          className='form-check-input'
                        />
                        <label className='form-check-label ms-2 text-gray-700'>
                          {values.ENABLE_ADDITIONAL_FEE ? 'On' : 'Off'}
                        </label>
                      </div>
                    </div>

                    {/* Fee fields */}
                    {values.ENABLE_ADDITIONAL_FEE && (
                      <div className='row'>
                        {/* Minimum Purchase */}
                        <div className='col-6'>
                          <label className='form-label fw-bold text-gray-700'>
                            Minimum Purchase Amount
                          </label>
                          <div className='d-flex align-items-center'>
                            <span className='me-2'>$</span>
                            <Field
                              placeholder='Enter minimum amount'
                              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              name='MINIMUM_PURCHASE_AMOUNT'
                              type='text'
                            />
                          </div>
                          <ErrorMessage
                            className='text-danger'
                            name='MINIMUM_PURCHASE_AMOUNT'
                            component='div'
                          />
                        </div>

                        {/* Additional Fee Percentage */}
                        <div className='col-6'>
                          <label className='form-label fw-bold text-gray-700'>
                            Additional Fee Percentage
                          </label>
                          <div className='d-flex align-items-center'>
                            <Field
                              placeholder='Enter fee percentage'
                              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              name='ADDITIONAL_FEE_PERCENTAGE'
                              type='text'
                            />
                            <span className='ms-2'>%</span>
                          </div>
                          <ErrorMessage
                            className='text-danger'
                            name='ADDITIONAL_FEE_PERCENTAGE'
                            component='div'
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='row p-5'>
                    <h5 className='text-gray-600'>Migration Status</h5>
                    {console.log('values.MIGRATION_STATUS  : ', values.MIGRATION_STATUS)}
                    <div className='row'>
                      <div className='col-6'>
                        <BSForm.Check
                          type='switch'
                          id='isActive'
                          label={values.MIGRATION_STATUS ? ' YES' : 'NO'}
                          checked={values.MIGRATION_STATUS}
                          onChange={(e) => {
                            setFieldValue('MIGRATION_STATUS', !values.MIGRATION_STATUS)
                          }}
                          name='isActive'
                          className={`form-control ${!values.MIGRATION_STATUS && 'checkbox-custom'
                            } no-background`}
                        />
                        <ErrorMessage
                          className='text-danger'
                          name='MIGRATION_STATUS'
                          component='div'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='row p-5'>
                    <h5 className='text-gray-600'>SWITCH ALL TRAFIC TO SINCH</h5>
                    <div className='row'>
                      <div className='col-6'>
                        <BSForm.Check
                          type='switch'
                          id='isActive'
                          label={values.SWITCH_ALL_TRAFIC_TO_SINCH ? ' YES' : 'NO'}
                          checked={values.SWITCH_ALL_TRAFIC_TO_SINCH}
                          onChange={(e) => {
                            setFieldValue(
                              'SWITCH_ALL_TRAFIC_TO_SINCH',
                              !values.SWITCH_ALL_TRAFIC_TO_SINCH
                            )
                          }}
                          name='isActive'
                          className={`form-control ${!values.SWITCH_ALL_TRAFIC_TO_SINCH && 'checkbox-custom'
                            } no-background`}
                        />
                        <ErrorMessage
                          className='text-danger'
                          name='SWITCH_ALL_TRAFIC_TO_SINCH'
                          component='div'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='modal-footer d-flex justify-content-center'>
                    <button type='submit' className='btn btn-primary ml-2'>
                      update
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}
      </div>
    </>
  )
}

export default GlobalSetting
